import {GridCellParams, GridFilterInputValue, GridFilterOperator} from "@mui/x-data-grid";
import {GeneCellData} from "../../types/list";

type MatchMode = 'contains' | 'equals' | 'containsanyof' | 'isanyof';

const createFilterOperator = (
  label: string,
  value: MatchMode,
  matcher: (cellValue: string, items: string[]) => boolean
): GridFilterOperator<any, string, string> => ({
  label,
  value,
  InputComponent: GridFilterInputValue,
  requiresFilterValue: true,
  getApplyFilterFn: (filterItem) => {
    if (!filterItem.field || !filterItem.value || !filterItem.operator) return null;

    let items = [filterItem.value.toLowerCase()];
    if (value.endsWith('anyof')) {
      items = filterItem.value
        .split(/[\s,]+/)
        .map((item: string) => item.trim())
        .filter(Boolean)
        .map((item: string) => item.toLowerCase());
    }

    return (params: GridCellParams<any, string, string>) => {
      const cellData = params.row[params.field] as GeneCellData;
      if (!cellData) return false;

      return [cellData.display, cellData.alternate || ""]
        .map((item) => item && item.toLowerCase())
        .filter(Boolean)
        .some((s) => matcher(s, items));
    };
  },
});

export const useGeneCellDataFilters = (): GridFilterOperator<any, string, string>[] => [
  createFilterOperator('contains', 'contains', (v, [item]) => v.includes(item)),
  createFilterOperator('equals', 'equals', (v, [item]) => v === item),
  createFilterOperator('contains any of', 'containsanyof', (v, items) => items.some((i) => v.includes(i))),
  createFilterOperator('is any of', 'isanyof', (v, items) => items.some((i) => v === i)),
];
